import { render, staticRenderFns } from "./FooterApp.vue?vue&type=template&id=fbf9f2d0&scoped=true"
import script from "./FooterApp.vue?vue&type=script&lang=js"
export * from "./FooterApp.vue?vue&type=script&lang=js"
import style0 from "./FooterApp.vue?vue&type=style&index=0&id=fbf9f2d0&prod&lang=stylus&scoped=true"
import style1 from "./FooterApp.vue?vue&type=style&index=1&id=fbf9f2d0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf9f2d0",
  null
  
)

export default component.exports